import React from 'react';
import { InfoSection, Pricing } from '../../components';
import { homeObjOne, homeObjThree, homeObjTwo, homeObjFour, productFeatures, ingredientes, opiniao} from './Data';

import FeaturesSection from '../../components/FeaturesSection/FeaturesSection'
import IngredientesSection from '../../components/IngredientesSection/IngredientesSection'
import InformacoesCompra from '../../components/InformacoesCompra/InformacoesCompra'
import OpinioesClientes from '../../components/OpinioesClientes/OpinioesClientes'



const Home = () => {
    return (
        <>
            <InfoSection {...homeObjOne} />
            <InformacoesCompra />
            <FeaturesSection features={productFeatures} titulo={"Alguns benefícios do novo PRÓ-FÍGADO que vão surpreender você!"} />

            <InfoSection {...homeObjThree} />
            <IngredientesSection
                ingredientes={ingredientes}
                titulo={"O segredo da cápsula mais poderosa do Brasil"}
                subtitulo={"5 ingredientes naturais reunidos em uma única cápsula"}
            />
            <OpinioesClientes features={opiniao} titulo={"O que as pessoas dizem sobre o PRÓ-FÍGADO"} />
            <Pricing />
            <InfoSection {...homeObjTwo} />            
        </>
    )
}

export default Home;